export default "__VITE_ASSET__1Z8TeVe4__"